(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',e=>{const button=e.target.closest('[data-mr-density]');if(!button)return;const grid=document.querySelector('ul#product-grid');if(!grid)return;const compact=button.dataset.mrDensity==='small';grid.classList.toggle('mr-dense-grid',compact);document.querySelectorAll('[data-mr-density]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});
  } catch(e) { console.error(e); }
})();

})();
